import React from 'react'
import AddNewSectionFilterSelect from './AddNewSectionFilterSelect.jsx';
import { Field } from 'formik';
import config from  '../../../../program-section-types-config.json'


const AddNewSectionFilter = ({genres, technicalAttributes, changeOption, values, currentGenreOption, filterActive, currentPeriodOption, currentAttributeOption}) => {
    const filterOptions = config.filterOptions
    if(!filterOptions) {
        return ''
    } else {
        const selectSettings = {
            menuShouldBlockScroll:true,
            isClearable:true,
            className:'select-container',
            isSearchable:false,
            classNamePrefix:"select"
        }

        if(genres) {
            const allGenres = {}

            Object.keys(genres).map(attrKey => {
                allGenres[attrKey] = genres[attrKey].name
            })

            filterOptions.genres.filter = allGenres
        }

        if(technicalAttributes) {
            const allTechnicalAttributes = {}

            Object.keys(technicalAttributes).map(attrKey => {
                allTechnicalAttributes[attrKey] = technicalAttributes[attrKey].name
            })

            filterOptions.technical.filter = allTechnicalAttributes
        }
    
        const activeFilterOptions = _.keys(filterOptions).map((filterID, index) => {
            const filter = filterOptions[filterID]
            const id = filterID

            return  <Field 
                        key={index} 
                        changeOption={changeOption}
                        currentGenreOption={currentGenreOption}
                        currentAttributeOption={currentAttributeOption}
                        currentPeriodOption={currentPeriodOption}
                        filter={filter}
                        filterActive={filterActive}
                        selectSettings={selectSettings}
                        values={values}
                        name={'options'}
                        id={id}
                        component={AddNewSectionFilterSelect}
                        genres={genres} 
                    />
        })
    
        return activeFilterOptions
    }
}

export default AddNewSectionFilter